module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common-module/common/customer-search-box/customer-search-box.component.scss
// module id = ./src/app/modules/common-module/common/customer-search-box/customer-search-box.component.scss
// module chunks = 9